// DEV-735 — the single answer to "which door does this pupil get".
//
// Pure logic, deliberately in its own module. It lives apart from
// utils/cookie because every consumer that mocks cookie I/O would otherwise
// have to mock this too, and a mocked answer here is worse than none: the
// whole point is that there is exactly one answer.
//
// getRedirect is the only consumer now. /email was a second one — it asked
// this whether offering the phone-login link would just bounce the user
// back — and the two disagreeing was not hypothetical: the link's guard was
// written against auth_model while routing moved to the door cookie, which
// put a school configured `pupil: passwordless` on top of
// `auth_model: roster_username` into an endless /email → / → /email loop.
//
// That guard is gone. Hiding the link was a way of living with the loop;
// utils/phoneForm fixes the loop itself, so the link is offered to
// everyone again and nothing outside routing needs to know about doors.

// Written by the school selector when identify configured no pupil door.
//
// A sentinel, not a deletion. Deleting would make "identify says this
// school offers pupils nothing" indistinguishable from "this user predates
// the cookie", and the transitional derivation below would then hand those
// pupils a door their school does not offer.
export const NO_PUPIL_DOOR = 'none';

export const resolvePupilDoor = (
  schoolPupilLogin?: string,
  schoolAuthModel?: string,
): string | undefined => {
  if (schoolPupilLogin === NO_PUPIL_DOOR) return undefined;
  if (schoolPupilLogin) return schoolPupilLogin;
  // Transitional only: users who picked a school before the door cookie
  // existed. Remove once those cookies have turned over. voucher_self
  // derives to nothing on purpose — there is no working flow to route into.
  if (schoolAuthModel === 'roster_username') return 'roster_phrase';
  if (schoolAuthModel === 'passwordless') return 'passwordless';
  return undefined;
};
